/* global G */
// see GAIA-514, GAIA-407
import { curry } from '@gaia/util'

/**
 * HTTP middleware filter that excludes `persistence`.
 *
 * @param params              http adapter middleware
 * @param params.persistence  excluded middleware
 * @param params.rest         used middleware
 * @return {any[]}
 */
const middleware = ({ persistence, ...rest }) => Object.values(rest)

const sequenceSessionCookieLoginFn = async (obj, args) => {
  console.log('sequenceSessionCookieLoginFn', obj, args)
  const result = await obj[G.ADAPTER][G.HTTP][G.API].post({
    url: '/api/v1/public/login',
    params: {
      username: 'demo',
      password: 'demo',
    },
  }, { middleware })
  console.log('sequenceSessionCookieLoginFn', result)
  // todo, move seqSessionSetValue to here
  return result
}

const sequenceSessionCookieLogin = curry(sequenceSessionCookieLoginFn)

export default sequenceSessionCookieLogin
